import { pushNotificationActions } from "../../actionTypes";

const initialState = {
	pushNotification: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case pushNotificationActions.CREATE_PUSH_NOTIFICATION: {
			return { ...initialState, fetching: true };
		}

		case pushNotificationActions.CREATE_PUSH_NOTIFICATION_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				pushNotification: action.payload,
			};
		}

		case pushNotificationActions.CREATE_PUSH_NOTIFICATION_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
